import { connect } from 'react-redux'
import { withWizard } from 'react-albus'
import { setWizards } from 'core/components/wizard/actions'
import Theming from './Theming'

const mapStateToProps = state => ({
  wizards: state.wizards
})

const mapDispatchToProps = {
  setWizards
}

// For test.js
export const ConnectedTheming = connect(mapStateToProps, mapDispatchToProps)(withWizard(Theming))

export default withWizard(connect(mapStateToProps, mapDispatchToProps)(Theming))
